import axios from 'axios'

type TMaker = {
  maker_name: string// eslint-disable-line camelcase
  maker_id: string// eslint-disable-line camelcase
}

type TMakerArray = {
  text: string
  value: string
}

const CONVERT_DATA = (_d) => {
  const arr:TMakerArray[] = []
  const D = _d.data.maker_array
  if (!D) return arr
  D.forEach((data:TMaker) => {
    arr.push({
      text: data.maker_name,
      value: data.maker_id
    })
  })
  return arr
}

const POST_REQ = async (_resolve, _path) => {
  const PARAMS = new URLSearchParams()
  const RESPONCE = await axios.post(_path, PARAMS).catch((e) => {
    _resolve(CONVERT_DATA(e.response))
  })
  RESPONCE && _resolve(CONVERT_DATA(RESPONCE))
}

export const getMaker = (_state, _props, _resolve, _reject) => {
  const PATH = process.env.END_MAKER_LIST
  POST_REQ(_resolve, PATH)
}
